define('drops/buttonWithIcon/buttonWithIcon',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/tooltip',
    'lq/onlongpress'
], function ($, Drop, Style, util, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            icon: '?',
            text: 'New Button with Icon',
            iconAlignment: 'left',
            title: {
                option: Tooltip.hardcoded
            },
            useDynamicWidth: true,
            useDynamicHeight: true,
            longPressDelay: 1000
        }
    };

    function ButtonWithIcon(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.defaultStyleSettings = {
            text: { verticalAlign: 'middle' }
        };

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$icon = $('<span class="drop-text-content">' + this.data.icon + '</span>');
        
        this.$text = $('<span class="text drop-text-content">' + this.data.text + '</span>');

        this.$button = $('<div/>')
            .addClass('boxToBorderSize drop-text-content')
            .attr('name', this.data.name)
            .append(this.data.iconAlignment === 'left' ? this.$icon : this.$text)
            .append(this.data.iconAlignment === 'left' ? this.$text : this.$icon)
            .attr('tabindex', this.data.tabIndex)
            .css({
                display: 'table-cell',
                width: '100%'
            });

        // WHY setting 'display: table' on $element would break centered anchoring, so we have to add a wrapper
        this.$element
            .append($('<div />')
                .css({
                    cursor: 'pointer',
                    display: 'table',
                    whiteSpace: 'pre-wrap',
                    height: '100%',
                    width: '100%'
                })
                .append(this.$button));

        if (!this.designData && this.isEventEnabled('onLongPress')) {
            OnLongPress.applyLongPressOnElement(this.$button, this);
        } else if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            var self = this;

            this.applyEventTrigger('clicked', 'click');

            this.$element
                .on('keypress', function (e) {
                    if (e.keyCode === 13) {
                        self.triggerEvent(self.data.eventing.clicked.raisedEventName);
                    }
	            });
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
    };

    Drop.extend(ButtonWithIcon);

    ButtonWithIcon.typeName = 'ButtonWithIcon';

    ButtonWithIcon.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$button);
        Style.renderStyles(this, null, this.$icon, this.data.styles, "buttonIcon");
    };

    ButtonWithIcon.prototype.preRender = function () {
        this.tooltip.update();

        this.piping.visibility.apply(this);
        this.applyPosition();

        this.renderStyles();
    };

    return ButtonWithIcon;
});
